export default __webpack_public_path__ + "static/media/1-text-slide.452512f8.png";